import {useCallback, useEffect} from 'react';

import {i18n} from 'i18next';
import Cookies from 'js-cookie';
import {useTranslation} from 'react-i18next';

import {Locale} from 'app/translations';
import {parseLocale} from 'app/translations/parser';

const COOKIES_NAME = 'locale';

export const useChangeLanguage = () => {
  const {i18n} = useTranslation();

  const changeLanguage = useCallback(
    (locale: Locale) => {
      i18n.changeLanguage(locale);

      Cookies.set(COOKIES_NAME, locale);
    },
    [i18n],
  );

  return changeLanguage;
};

export const useLanguageInit = (i18n: i18n) => {
  const changeLanguage = useChangeLanguage();

  useEffect(() => {
    const locale = parseLocale(getCurrentLocale());

    if (locale !== i18n.language) {
      changeLanguage(locale);
    }
  }, [changeLanguage, i18n]);
};

export const getCurrentLocale = () => Cookies.get(COOKIES_NAME) as Locale;
